import React from 'react';
import { Link, Redirect } from 'react-router-dom';

const Reseller = ({ UserSubs, getNextPaginationUrl, isReseller }) => {
  if (!isReseller) {
    return <Redirect to="/" />;
  }

  return (
    <section>
      <h1>Reseller Page</h1>
      <p>
        <Link to={`/reseller/`}>Sprint subscriptions</Link>
      </p>
      <p>
        <Link to={`/reseller/att/`}>AT&amp;T subscriptions</Link>
      </p>

      <UserSubs isReseller getNextPaginationUrl={getNextPaginationUrl} />
    </section>
  );
};

export default Reseller;
